// Technical, quiet backdrop: masked grid, one warm glow, one faint cool glow, three slow data lines, a few drifting points. CSS + inline SVG only.
export default function Backdrop({ lines = true, dots = 5, cool = true, className = "" }) {
  return (
    <div className={`hp-backdrop ${className}`} aria-hidden data-testid="hero-backdrop">
      <div className="hp-glow" />
      {cool && <div className="hp-glow-cool" />}
      <div className="hp-grid" />
      {lines && (
        <svg className="hp-lines" viewBox="0 0 1440 800" preserveAspectRatio="none">
          <defs><linearGradient id="hpLine" x1="0" x2="1"><stop offset="0" stopColor="rgba(245,158,11,0)" /><stop offset=".5" stopColor="rgba(245,158,11,.55)" /><stop offset="1" stopColor="rgba(245,158,11,0)" /></linearGradient></defs>
          <path d="M-40 620 C 240 560, 420 700, 720 640 S 1180 520, 1500 600" />
          <path d="M-40 180 C 300 120, 520 260, 860 200 S 1240 120, 1500 180" />
          <path d="M-40 420 C 260 470, 540 360, 900 410 S 1300 470, 1500 400" />
        </svg>
      )}
      {Array.from({ length: dots }).map((_, i) => <span key={i} className="hp-dot" style={{ left: `${12 + i * 17}%`, top: `${18 + (i % 3) * 22}%`, animationDelay: `${-i * 6}s`, animationDuration: `${24 + i * 5}s` }} />)}
    </div>
  );
}
